export default __webpack_public_path__ + "static/media/logo-menu.a05f2911.png";